module.exports = __webpack_public_path__ + "static/media/style-persona-3.63df0c2e.png";